import {
  CommonHelperFunctions,
  IDocumentParametersSettings,
  IProjectSettings,
  ISourceRepositorySettings
} from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";

const backendUrl: string = CommonHelperFunctions.GetBackendUrl();

export class ProjectSettingsService {
  public static getProjectSettings(projectId: string): Promise<AxiosResponse<IProjectSettings>> {
    return Axios.get<IProjectSettings>(`${backendUrl}/ProjectSettings/project/${projectId}`);
  }

  public static upsertSourceRepository(
    projectId: string,
    settings: ISourceRepositorySettings
  ): Promise<AxiosResponse<void>> {
    return Axios.put<void>(`${backendUrl}/ProjectSettings/project/${projectId}/sourcerepository`, settings);
  }

  public static deleteSourceRepository(projectId: string): Promise<AxiosResponse<void>> {
    return Axios.delete<void>(`${backendUrl}/ProjectSettings/project/${projectId}/sourcerepository`);
  }

  public static getDocumentParameters(projectId: string): Promise<AxiosResponse<IDocumentParametersSettings>> {
    return Axios.get<IDocumentParametersSettings>(
      `${backendUrl}/ProjectSettings/project/${projectId}/documentparameters`
    );
  }

  /** Replaces the whole definition list — the panel edits it as a unit. */
  public static upsertDocumentParameters(
    projectId: string,
    settings: IDocumentParametersSettings
  ): Promise<AxiosResponse<void>> {
    return Axios.put<void>(`${backendUrl}/ProjectSettings/project/${projectId}/documentparameters`, settings);
  }
}
